import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import LocalStorageHelper from '../LocalStorageHelper/LocalStorageHelper';

class ProtectedRoute extends Component {
    render() {
        const { component: Component, render, ...rest } = this.props;
        const isAuthenticated = JSON.parse(LocalStorageHelper.getUser()) !== null;

        return (
            <Route
                {...rest}
                render={(props) => {
                    if (isAuthenticated) {
                        if (Component) {
                            return <Component {...props} />;
                        } else if (render) {
                            return render(props);
                        }
                    }
                    return <Redirect to={{ pathname: '/login' }} />;
                }}
            />
        );
    }
}

export default ProtectedRoute;




/* import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LocalStorageHelper from '../LocalStorageHelper/LocalStorageHelper';

class ProtectedRoute extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const Component = this.props.component;
        const isAuthenticated = JSON.parse(LocalStorageHelper.getUser()) !== null ? true : false;
        return isAuthenticated ?
            <Component {...this.props}/> :
            <Redirect to={{ pathname: '/login' }} />
    }

}

export default ProtectedRoute; */